/** Keep only the origin; referral URLs can contain private paths and parameters. */
export function getReferrerOrigin(referrer: string): string {
  if (!referrer) return "";
  try {
    const referrerUrl = new URL(referrer);
    if (!["http:", "https:"].includes(referrerUrl.protocol)
      || referrerUrl.username || referrerUrl.password) return "";
    const referrerOrigin = `${referrerUrl.origin}/`;
    return referrerOrigin.length <= 2048 ? referrerOrigin : "";
  } catch {
    return "";
  }
}
